<template>
  <div class="Index">
    <!-- <div class="content-box">
      <div class="go-back" @click="goback">返 回</div>
      <div class="routine-box"></div>
      <div class="routine-321"></div>
    </div> -->
    <div class="content-theme">
      <div class="content-theme-title">
        <div
          v-for="(item, index) in detailList"
          :key="index"
          :class="index === activeDetail ? 'active' : 'setting'"
          @click="handleDetailToggle(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <div class="content-theme-content">
      <div class="content-theme-content-title">
        <div v-for="(item, index) in questionToggleList" :key="index">
          <div class="questionList-title" @click="pageJumpUrl(item.url)">
            <div class="questionList-title-img">
              <div class="questionList-title-img-title">Q{{ index + 1 }}</div>
            </div>
            <div>{{ item.label }}</div>
            <img
              v-if="index < 3"
              class="questionList-title-fire"
              src="@/assets/modify/list/fire.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-list">
      <div class="toggle-list-card" @click="toggleCardMode">
        <img
          class="toggle-list-card-img"
          src="@/assets/modify/list/card.png"
          alt=""
        />
        <div class="toggle-list-card-title">切换为卡片模式</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      detailList: [
        {
          label: "医疗健康",
          questionList: [
                   {
          label: "如何使用微信完成预约挂号?",
          url: "/health/register/wx/index1",
        },
        {
          label: "如何使用支付宝完成预约挂号?",
          url: "/health/register/zfb/index1",
        },
        {
          label: "微信预约挂号时如何添加就诊人?",
          url: "/health/register/wx/branch1/index1",
        },
        {
          label: "支付宝预约挂号时如何添加就诊人?",
          url: "/health/register/zfb/branch1/index1",
        },
        {
          label: "微信预约挂号后如何使用就诊码报到?",
          url: "/health/register/wx/branch2/index1",
        },
        {
          label: "支付宝预约挂号后如何使用就诊码报到?",
          url: "/health/register/zfb/branch2/index1",
        },
        {
          label: "如何使用微信激活电子医保?",
          url: "/health/activation/wx/index1",
        },
        {
          label: "如何使用支付宝激活电子医保?",
          url: "/health/activation/zfb/index1",
        },
        { label: "如何使用微信查看电子医保码?", url: "/health/pay/wx/index1" },
        {
          label: "如何使用支付宝查看电子医保码?",
          url: "/health/pay/wx/index1",
        },
        {
          label: "如何使用微信查询电子医保账户余额?",
          url: "/health/query/wx/index1",
        },
        {
          label: "如何使用支付宝查询电子医保账户余额?",
          url: "/health/query/zfb/index1",
        },
        {
          label: "如何使用微信完成手机线上买药?",
          url: "/health/medicine/wx/index1",
        },
        {
          label: "如何使用支付宝完成手机线上买药?",
          url: "/health/medicine/zfb/index1",
        },
        {
          label: "微信如何查看线上已购买的药品?",
          url: "/health/medicine/wx/branch1/index1",
        },
        {
          label: "支付宝如何查看线上已购买的药品?",
          url: "/health/medicine/zfb/branch1/index1",
        },
          ],
        },
        {
          label: "社会保障",
          questionList: [
            // {
            //   label: "如何完成城乡居民养老保险缴费?",
            //   url: "/society/resident/index",
            // },
            // {
            //   label: "如何完成城乡居民养老保险待遇申请?",
            //   url: "/society/retirement/index",
            // },
            // {
            //   label: "如何完成每年度的养老待遇资格认证?",
            //   url: "/society/authentication/index",
            // },
            // {
            //   label: "如何查询养老保险待遇发放明细?",
            //   url: "/society/Query/index",
            // },
            {
              label: "如何使用微信申领电子社保卡?",
              url: "/society/apply/wx/index1",
            },
            {
              label: "如何使用支付宝申领电子社保卡?",
              url: "/society/apply/zfb/index1",
            },
            {
              label: "社保卡丢失如何使用微信进行临时挂失?",
              url: "/society/temporary/wx/index1",
            },
            {
              label: "社保卡丢失如何使用支付宝进行临时挂失?",
              url: "/society/temporary/zfb/index1",
            },
          ],
        },
        {
          label: "生活缴费",
          questionList: [
            { label: "如何使用微信给手机充值话费?", url: "/life/phone/wx/index1" },
            { label: "如何使用支付宝给手机充值话费?", url: "/life/phone/zfb/index1" },
            { label: "如何使用微信线上缴纳电费?", url: "/life/electricity/wx/index1" },
            { label: "如何使用支付宝线上缴纳电费?", url: "/life/electricity/zfb/index1" },
            {
              label: "如何使用支付宝开通电费自动缴费?",
              url: "/life/electricity/zfb/branch/index1",
            },
            { label: "如何使用微信线上缴纳水费?", url: "/life/water/wx/index1" },
            { label: "如何使用支付宝线上缴纳水费?", url: "/life/water/zfb/index1" },
            {
              label: "如何使用支付宝开通水费自动缴费?",
              url: "/life/water/zfb/branch1/index1",
            },
            { label: "如何使用微信线上缴纳燃气费?", url: "/life/gas/wx/index1" },
            { label: "如何使用支付宝线上缴纳燃气费?", url: "/life/gas/zfb/index1" },
            {
              label: "如何使用支付宝开通燃气费自动缴费?",
              url: "/life/gas/zfb/branch1/index1",
            },
            { label: "如何使用微信线上缴纳有限电视费?", url: "/life/television/wx/index1" },
            { label: "如何使用支付宝线上缴纳有限电视费?", url: "/life/television/zfb/index1" },
          ],
        },
        {
          label: "交通出行",
          questionList: [
            { label: "如何使用微信呼叫网约车?", url: "/traffic/car/wx/index1" },
            { label: "如何使用支付宝呼叫网约车?", url: "/traffic/car/zfb/index1" },
            {
              label: "如何使用百度地图呼叫网约车?",
              url: "/traffic/car/bd/index1",
            },
            {
              label: "如何使用高德地图呼叫网约车?",
              url: "/traffic/car/gd/index1",
            },

            {
              label: "如何使用百度地图预约网约车?",
              url: "/traffic/car/bd/branch2/index1",
            },

            { label: "如何使用百度地图查看路线?", url: "/traffic/line/bd/index1" },
            { label: "如何使用高德地图查看路线?", url: "/traffic/line/gd/index1" },
            {
              label: "百度地图如何取消网约车订单?",
              url: "/traffic/car/bd/branch1/index1",
            },
            {
              label: "高德地图如何取消网约车订单?",
              url: "/traffic/car/gd/branch1/index1",
            },
            // {
            //   label: "如何使用乘车码乘坐地铁和公交?",
            //   url: "/traffic/code/index",
            // },
            { label: "如何使用微信购买火车票?", url: "/traffic/train/wx/index1" },
            { label: "如何使用支付宝购买火车票?", url: "/traffic/train/zfb/index1" },
            { label: "如何使用铁路12306购买火车票?", url: "/traffic/train/tl/index1" },
            {
              label: "如何在铁路12306购买火车票时添加乘车人?",
              url: "/traffic/train/tl/branch1/index1",
            }, //12306添加乘车人
            {
              label: "如何在铁路12306进行火车票改签?",
              url: "/traffic/train/tl/branch2/index1",
            }, //12306改签
            {
              label: "如何在铁路12306进行火车票退票?",
              url: "/traffic/train/tl/branch3/index1",
            }, //12306退票
            { label: "如何使用微信购买飞机票?", url: "/traffic/aircraft/wx/index1" },
            { label: "如何使用支付宝购买飞机票?", url: "/traffic/aircraft/zfb/index1" },
            { label: "如何使用铁路12306购买飞机票?", url: "/traffic/aircraft/tl/index1" },
            {
              label: "如何在微信购买飞机票时添加乘机人?",
              url: "/traffic/aircraft/wx/branch/index1",
            },
          ],
        },
        {
          label: "购物消费",
          questionList: [
            { label: "如何使用淘宝买菜?", url: "/shopping/dish/tb/index1" },
            { label: "如何使用拼多多买菜?", url: "/shopping/dish/pdd/index1" },
            {
              label: "淘宝买菜订单如何申请退款?",
              url: "/shopping/dish/tb/branch/index1",
            }, //美团
            {
              label: "拼多多买菜订单如何申请退款?",
              url: "/shopping/dish/pdd/branch/index1",
            }, //美团
            { label: "如何使用美团点外卖?", url: "/shopping/eat/mt/index1" },
            { label: "如何使用饿了么点外卖?", url: "/shopping/eat/elm/index1" },
            { label: "如何使用京东点外卖?", url: "/shopping/eat/jd/index1" },
            {
              label: "淘宝网购后商品退货如何让快递员上门取件?",
              url: "/shopping/refund/tb/index1",
            },
            {
              label: "京东网购后商品退货如何让快递员上门取件?",
              url: "/shopping/refund/jd/index1",
            },
            {
              label: "拼多多网购后商品退货如何让快递员上门取件?",
              url: "/shopping/refund/pdd/index1",
            },
            {
              label: "抖音网购后商品退货如何让快递员上门取件?",
              url: "/shopping/refund/dy/index1",
            },
            {
              label: "拼多多网购后商品退货如何在快递柜自行退件?",
              url: "/shopping/refund/pdd/branch1/index1",
            },
            {
              label: "淘宝网购后商品退货如何在驿站自行退件?",
              url: "/shopping/refund/tb/branch1/index1",
            },
            {
              label: "淘宝网购后商品换货如何让快递员上门取件?",
              url: "/shopping/change/tb/index1",
            },
            {
              label: "京东网购后商品换货如何让快递员上门取件?",
              url: "/shopping/change/jd/index1",
            },

            {
              label: "拼多多网购后商品换货如何在快递柜自行退件?",
              url: "/shopping/change/pdd/branch1/index1",
            }, //拼多多
            {
              label: "抖音网购后商品换货如何在快递柜自行退件?",
              url: "/shopping/change/dy/branch1/index1",
            }, //拼多多
            {
              label: "网购后商品换货如何在驿站自行退件?",
              url: "/shopping/change/pdd/branch2/index1",
            }, //拼多多
            {
              label: "淘宝网购维权时如何找到官方客服?",
              url: "/shopping/power/tb/index1",
            },
            {
              label: "京东网购维权时如何找到官方客服?",
              url: "/shopping/power/jd/index1",
            },
            {
              label: "拼多多网购维权时如何找到官方客服?",
              url: "/shopping/power/pdd/index1",
            },
            {
              label: "抖音网购维权时如何找到官方客服?",
              url: "/shopping/power/dy/index1",
            },
          ],
        },
      ],
      //激活对象
      activeDetail: 0,
      //问题列表
      questionToggleList: [
        {
          label: "如何使用微信完成预约挂号?",
          url: "/health/register/wx/index1",
        },
        {
          label: "如何使用支付宝完成预约挂号?",
          url: "/health/register/zfb/index1",
        },
        {
          label: "微信预约挂号时如何添加就诊人?",
          url: "/health/register/wx/branch1/index1",
        },
        {
          label: "支付宝预约挂号时如何添加就诊人?",
          url: "/health/register/zfb/branch1/index1",
        },
        {
          label: "微信预约挂号后如何使用就诊码报到?",
          url: "/health/register/wx/branch2/index1",
        },
        {
          label: "支付宝预约挂号后如何使用就诊码报到?",
          url: "/health/register/zfb/branch2/index1",
        },
        {
          label: "如何使用微信激活电子医保?",
          url: "/health/activation/wx/index1",
        },
        {
          label: "如何使用支付宝激活电子医保?",
          url: "/health/activation/zfb/index1",
        },
        { label: "如何使用微信查看电子医保码?", url: "/health/pay/wx/index1" },
        {
          label: "如何使用支付宝查看电子医保码?",
          url: "/health/pay/wx/index1",
        },
        {
          label: "如何使用微信查询电子医保账户余额?",
          url: "/health/query/wx/index1",
        },
        {
          label: "如何使用支付宝查询电子医保账户余额?",
          url: "/health/query/zfb/index1",
        },
        {
          label: "如何使用微信完成手机线上买药?",
          url: "/health/medicine/wx/index1",
        },
        {
          label: "如何使用支付宝完成手机线上买药?",
          url: "/health/medicine/zfb/index1",
        },
        {
          label: "微信如何查看线上已购买的药品?",
          url: "/health/medicine/wx/branch1/index1",
        },
        {
          label: "支付宝如何查看线上已购买的药品?",
          url: "/health/medicine/zfb/branch1/index1",
        },
      ],
    };
  },
  methods: {
    goback() {
      this.$router.replace({
        path: "/classification",
      });
    },
    handleDetailToggle(index) {
      this.activeDetail = index;
      this.questionToggleList = this.detailList[index].questionList;
    },
    toggleCardMode() {
      this.$router.replace({
        path: "/classification",
      });
    },
    pageJumpUrl(url) {
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/modify/mainBg/rectangle_20250106.png) no-repeat
    center;
  background-size: 100% 100%;
  border-radius: 0px;
}
.content-box {
  display: flex;
  justify-content: space-evenly;
  padding-top: 40px;
  box-sizing: border-box;
}

.content-theme {
  width: 100%;
  .content-theme-title {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    font-size: 25px;
    padding-top: 70px;
    box-sizing: border-box;
  }
}
.setting {
  color: rgb(255, 106, 39);
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11-2.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  box-sizing: border-box;
  border: 3px solid rgb(249, 199, 160);
  box-shadow: 0px 8px 17px 0px rgba(238, 172, 111, 0.35);
}
.active {
  color: rgb(255, 255, 255);
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 15px;

  box-sizing: border-box;
  border: 3px solid rgb(249, 199, 160);
  box-shadow: 0px 8px 17px 0px rgba(238, 172, 111, 0.79);
}
.content-theme-content {
  width: 95%;
  height: 70%;
  margin: 0 auto;
  overflow-y: auto;
  margin-top: 40px;
}
.content-theme-content-title {
  // height: 100%;
  margin: 0 30px;
  box-sizing: border-box;
}
.questionList-title {
  border-radius: 15px;
  box-shadow: 0px 14px 23px -9px rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);
  width: 100%;
  height: 90px;
  font-size: 30px;
  color: #373737;
  box-sizing: border-box;
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.questionList-title-fire {
  width: 35px;
  height: 35px;
  margin-left: 15px;
  // margin-top: 12px;
}
.questionList-title-img {
  width: 45px;
  height: 45px;
  margin: 0px 20px 0 30px;
  background: url(@/assets/modify/list/group-4.png) no-repeat center;
  background-size: 100% 100%;
}
.questionList-title-img-title {
  color: #d3f0e1;
  margin-top: 7px;
  font-size: 16px;
  margin-left: 6px;
}
.toggle-list {
  // margin: 15px 0;
}
.toggle-list-card {
  width: 60%;
  height: 100px;
  line-height: 100px;
  margin: 0 auto;
  background: url(@/assets/modify/list/group-26.png) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  color: #ffffff;
  margin-top: 15px;
  font-weight: 500;
}
.toggle-list-card-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
</style>
